var _path, _g, _rect, _path2, _polygon, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.629,73.444v375.795h375.795L14.629,73.444z M81.734,235.453l146.681,146.681H81.734V235.453z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.423,463.868H14.629C6.549,463.868,0,457.318,0,449.239V73.444 c0-5.916,3.565-11.251,9.03-13.515c5.465-2.265,11.758-1.012,15.941,3.17l375.795,375.795c4.184,4.184,5.436,10.477,3.171,15.942 C401.674,460.304,396.341,463.868,390.423,463.868z M29.257,434.61h325.85l-325.85-325.85V434.61z M228.415,396.762H81.736 c-8.079,0-14.629-6.549-14.629-14.629V235.453c0-5.916,3.565-11.251,9.03-13.515c5.465-2.265,11.757-1.012,15.942,3.17 L238.76,371.788c4.184,4.184,5.435,10.476,3.17,15.941C239.666,393.197,234.331,396.762,228.415,396.762z M96.364,367.505h96.734 L96.364,270.77L96.364,367.505L96.364,367.505z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.832,463.868c-4.604,0-8.94-2.168-11.703-5.851l-34.54-46.052 c-1.899-2.532-2.926-5.612-2.926-8.777V62.761c0-8.079,6.549-14.629,14.629-14.629h69.079c8.079,0,14.629,6.549,14.629,14.629 v83.342c0,8.079-6.549,14.629-14.629,14.629s-14.629-6.549-14.629-14.629V77.39h-39.822v320.92l19.911,26.548l19.911-26.548 V209.047c0-8.079,6.549-14.629,14.629-14.629S512,200.967,512,209.047v194.14c0,3.166-1.027,6.245-2.926,8.777l-34.54,46.052 C471.771,461.7,467.436,463.868,462.832,463.868z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 428.295,
    y: 62.761,
    width: 69.076,
    height: 57.563
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497.371,134.956h-69.079c-8.079,0-14.629-6.549-14.629-14.629V62.761 c0-8.079,6.549-14.629,14.629-14.629h69.079c8.079,0,14.629,6.549,14.629,14.629v57.566 C512,128.407,505.451,134.956,497.371,134.956z M442.921,105.699h39.822V77.39h-39.822V105.699z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "428.292,393.975 428.292,403.185 462.832,449.239 497.371,403.185 497.371,393.975 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M462.832,463.868L462.832,463.868c-4.604,0-8.94-2.168-11.703-5.851l-34.54-46.054 c-1.899-2.532-2.926-5.612-2.926-8.777v-9.21c0-8.079,6.549-14.629,14.629-14.629h69.079c8.079,0,14.629,6.549,14.629,14.629v9.21 c0,3.166-1.027,6.245-2.926,8.777l-34.54,46.054C471.771,461.7,467.436,463.868,462.832,463.868z M450.642,408.604l12.19,16.254 l12.19-16.254H450.642z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.1ebe3a4a.svg";
export { ForwardRef as ReactComponent };